<div class="tab-pane" role="tabpanel" id="recepcion">
    <fieldset id="agregar_recepcion" class="">
        <div class="step_section">
            <form [formGroup]="form">
                <h3 class="form-signin-heading"><strong>NUMERO DE UNIDADES TOTALES POR DESTINO</strong></h3>
                <hr />
                <div class="form-horizontal" style="font-size: 14px">
                    <div class="form-group" align="left">
                        <div class="col-md-2">
                            <label for="vivienda" style="padding-bottom: 20px; padding-top: 16px;">VIVIENDAS</label>
                        </div>
                        <div class="col-md-2">
                            <mat-form-field class="example-full-width" style="width: 145px;">
                                <input matInput placeholder="Viviendas" id="vivienda" name="vivienda" formControlName="vivienda" (change)="add_unidades()" [errorStateMatcher]="matcher" />

                            </mat-form-field>
                        </div>
                        <div class="col-md-2"></div>
                        <div class="col-md-2">
                            <label for="oficinas" style="padding-bottom: 20px; padding-top: 16px;">OFICINAS</label>
                        </div>
                        <div class="col-md-2">
                            <mat-form-field class="example-full-width" style="width: 145px;">
                                <input matInput placeholder="Oficinas" id="oficinas" name="oficinas" formControlName="oficinas" (change)="add_unidades()" [errorStateMatcher]="matcher" />
                                <mat-error *ngIf="form.controls?.oficinas.hasError('required')">
                                    Este campo es <strong>obligatorio</strong>
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="form-group" align="left">
                        <div class="col-md-2">
                            <label for="locales" style="padding-bottom: 20px; padding-top: 16px;">LOCALES COMERCIALES</label>
                        </div>
                        <div class="col-md-2">
                            <mat-form-field class="example-full-width" style="width: 145px;">
                                <input matInput placeholder="Locales Comerciales" id="locales" name="locales" formControlName="locales" (change)="add_unidades()" [errorStateMatcher]="matcher" />
                                <mat-error *ngIf="form.controls?.locales.hasError('required')">
                                    Este campo es <strong>obligatorio</strong>
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-2"></div>
                        <div class="col-md-2">
                            <label for="estacionamientos" style="padding-bottom: 20px; padding-top: 16px;">ESTACIONAMIENTOS</label>
                        </div>
                        <div class="col-md-2">
                            <mat-form-field class="example-full-width" style="width: 145px;">
                                <input matInput placeholder="Estacionamientos" id="estacionamientos" name="estacionamientos" formControlName="estacionamientos" (change)="add_unidades()" [errorStateMatcher]="matcher" />
                                <mat-error *ngIf="form.controls?.estacionamientos.hasError('required')">
                                    Este campo es <strong>obligatorio</strong>
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="form-group" align="left">
                        <div class="col-md-2">
                            <label for="otros" style="padding-bottom: 20px; padding-top: 16px;">OTROS (ESPECIFICAR)</label>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field class="example-full-width" style="width: 145px;">
                                <input matInput placeholder="Otros" id="otros" name="otros" formControlName="otros" (change)="add_unidades()" [errorStateMatcher]="matcher" />
                                <mat-error *ngIf="form.controls?.otros.hasError('required')">
                                    Este campo es <strong>obligatorio</strong>
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </fieldset>
</div>
<div class="separator"></div>